import { SelectOption } from '@common/types/common';
import { ToastOptions } from 'react-toastify';

const APP_PREFIX_PATH = '/app';

const BASE_URL = import.meta.env.VITE_REACT_APP_API_ENDPOINT ?? '';
const VICTRON_BASE_URL = import.meta.env.VITE_VICTRON_ENERGY_API_ENDPOINT ?? '';
const MUI_LICENSE_KEY = import.meta.env.VITE_MUI_LICENSE;
const IS_DEV = import.meta.env.DEV;
const IS_PROD = import.meta.env.PROD;
const GOOGLE_MAP_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
const SENTRY_ENV = import.meta.env.VITE_REACT_SENTRY_ENV;
const TEST_ENV_CREDENTIALS = import.meta.env.TEST_ENV_CREDENTIALS ?? '';
const GOOGLE_RECAPTCHA_SITE_KEY = import.meta.env.VITE_GOOGLE_RECAPTCHA_SITE_KEY ?? '';
const VE_DJANGO_CMS = import.meta.env.VITE_VE_DJANGO_CMS ?? '';

const HIDE_SIDEBAR_KEY = 'hideSideBar';

const DEFAULT_TOAST_PROPS: ToastOptions = {
    position: 'top-right',
    autoClose: 5000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    theme: 'colored',
};

const URL_REGEX = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
const QUESTIONNAIRE_ID_MAX_LENGTH = 20;
const ISO_TZ_FORMAT = "yyyy-MM-dd'T'HH:mm:ssxxx";
const COUNTRIES_WITH_STATES = ['US', 'AU', 'ZA', 'ES'];
const FALLBACK_LANGUAGES: SelectOption[] = [{ value: 'en', label: 'English' }];

export {
    APP_PREFIX_PATH,
    BASE_URL,
    COUNTRIES_WITH_STATES,
    DEFAULT_TOAST_PROPS,
    EMAIL_REGEX,
    FALLBACK_LANGUAGES,
    GOOGLE_MAP_API_KEY,
    GOOGLE_RECAPTCHA_SITE_KEY,
    HIDE_SIDEBAR_KEY,
    IS_DEV,
    IS_PROD,
    ISO_TZ_FORMAT,
    MUI_LICENSE_KEY,
    QUESTIONNAIRE_ID_MAX_LENGTH,
    SENTRY_ENV,
    TEST_ENV_CREDENTIALS,
    URL_REGEX,
    VE_DJANGO_CMS,
    VICTRON_BASE_URL,
};
